function getConfig(domain) {
  switch (domain) {
    case 'join.peachjar.net':
    case 'localhost': return {
      ENVIRONMENT: 'development',
      REACT_APP_STRIPE_PUBLISHABLE_API_KEY: 'pk_test_GiDwCCPgFja8BYFetGdLMlix',
      REACT_APP_API_BASE_URL: 'https://portal-api.peachjar.net:10443',
      REACT_APP_GRAPHQL_URI: 'https://portal-api.peachjar.net:10443/graphql',
      REACT_APP_ACCOUNTS_APP_URL: 'https://accounts.peachjar.net:10443',
      REACT_APP_INTERNAL_APP_URL: 'https://internal.peachjar.net:10443',
      REACT_APP_PORTAL_APP_URL: 'https://portal.peachjar.net:10443',
      REACT_APP_SCHOOL_ONBOARDING_URL: 'https://join.peachjar.net:10443',
      REACT_APP_GEOCORE_LEGACY_APP_URL: 'https://dev.peachjar.com/index.php?a=4',
      REACT_APP_SENTRY_API_KEY: 'e452b76ede9f4fd3890d418ea13087aa',
      REACT_APP_SENTRY_PROJECT_ID: '1186595',
      REACT_APP_ONBOARDING_MARKETING_PAGE :  'https://info.peachjar.com/schoolonboarding',
      REACT_APP_CDN_URL :  'https://cdn-assets.peachjar.com',
      REACT_APP_FEATURE_PORTAL: true,
      REACT_APP_PEACHJAR_HOME_PAGE: 'https://dev.peachjar.com',
    };
    case 'join.peachjar-kauai.com': return {
      ENVIRONMENT: 'staging',
      REACT_APP_STRIPE_PUBLISHABLE_API_KEY: 'pk_test_GiDwCCPgFja8BYFetGdLMlix',
      REACT_APP_API_BASE_URL: 'https://portal-api.peachjar-kauai.com',
      REACT_APP_GRAPHQL_URI: 'https://portal-api.peachjar-kauai.com/graphql',
      REACT_APP_ACCOUNTS_APP_URL: 'https://accounts.peachjar-kauai.com',
      REACT_APP_INTERNAL_APP_URL: 'https://internal.peachjar-kauai.com',
      REACT_APP_PORTAL_APP_URL: 'https://portal.peachjar-kauai.com',
      REACT_APP_SCHOOL_ONBOARDING_URL: 'https://join.peachjar-kauai.com',
      REACT_APP_GEOCORE_LEGACY_APP_URL: 'https://dev.peachjar.com/index.php?a=4',
      REACT_APP_GEOCORE_LOGIN_URL: 'https://peachjar.com/index.php?a=10',
      REACT_APP_SENTRY_API_KEY: 'e452b76ede9f4fd3890d418ea13087aa',
      REACT_APP_SENTRY_PROJECT_ID: '1186595',
      REACT_APP_ONBOARDING_MARKETING_PAGE: 'https://info.peachjar.com/schoolonboarding',
      REACT_APP_CDN_URL: 'https://cdn-assets.peachjar.com',
      REACT_APP_FEATURE_PORTAL: true,
      REACT_APP_PEACHJAR_HOME_PAGE: 'https://www.peachjar-staging.com',
    };
    default:
      return {
        ENVIRONMENT: 'production',
        REACT_APP_STRIPE_PUBLISHABLE_API_KEY: 'pk_live_2fPih1800WS1Iiwhdc4TfWFR',
        REACT_APP_API_BASE_URL: 'https://portal-api.peachjar.com',
        REACT_APP_GRAPHQL_URI: 'https://portal-api.peachjar.com/graphql',
        REACT_APP_ACCOUNTS_APP_URL: 'https://accounts.peachjar.com',
        REACT_APP_INTERNAL_APP_URL: 'https://internal.peachjar.com',
        REACT_APP_PORTAL_APP_URL: 'https://portal.peachjar.com',
        REACT_APP_SCHOOL_ONBOARDING_URL: 'https://join.peachjar.com',
        REACT_APP_GEOCORE_LEGACY_APP_URL: 'https://www.peachjar.com/index.php?a=4',
        REACT_APP_SENTRY_API_KEY: 'e452b76ede9f4fd3890d418ea13087aa',
        REACT_APP_SENTRY_PROJECT_ID: '1186595',
        REACT_APP_ONBOARDING_MARKETING_PAGE: 'https://info.peachjar.com/schoolonboarding',
        REACT_APP_CDN_URL: 'https://cdn-assets.peachjar.com',
        REACT_APP_FEATURE_PORTAL: true,
        REACT_APP_PEACHJAR_HOME_PAGE: 'https://www.peachjar.com',
      };
  }
}

export default getConfig(window.location.hostname);



// WEBPACK FOOTER //
// ./src/config.js